import { Icon, InlineIcon } from '@iconify/react';
import leftSmallOutline from '@iconify/icons-teenyicons/left-small-outline';
import moreHorizontalSolid from '@iconify/icons-teenyicons/more-horizontal-solid';
import searchOutline from '@iconify/icons-teenyicons/search-outline';
import filterOutline from '@iconify/icons-teenyicons/filter-outline';
import downSmallOutline from '@iconify/icons-teenyicons/down-small-outline';
import envelopeOutline from '@iconify/icons-teenyicons/envelope-outline';
import userSolid from '@iconify/icons-teenyicons/user-solid';
import phoneOutline from '@iconify/icons-teenyicons/phone-outline';
import passwordOutline from '@iconify/icons-teenyicons/password-outline';
import addSmallOutline from '@iconify/icons-teenyicons/add-small-outline';
import minusSmallOutline from '@iconify/icons-teenyicons/minus-small-outline';
import contactSolid from '@iconify/icons-teenyicons/contact-solid';
import idSolid from '@iconify/icons-teenyicons/id-solid';
import edit1Solid from '@iconify/icons-teenyicons/edit-1-solid';
import logoutOutline from '@iconify/icons-teenyicons/logout-outline';
import binSolid from '@iconify/icons-teenyicons/bin-solid';

const Outline = {
  left: leftSmallOutline,
  search: searchOutline,
  filter: filterOutline,
  down: downSmallOutline,
  envelope: envelopeOutline,
  phone: phoneOutline,
  password: passwordOutline,
  add: addSmallOutline,
  minus: minusSmallOutline,
  logout: logoutOutline,
};

const Solid = {
  moreHorizontal: moreHorizontalSolid,
  user: userSolid,
  contact: contactSolid,
  id: idSolid,
  edit: edit1Solid,
  bin: binSolid,
};

export { Icon, InlineIcon, Outline, Solid };
